module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAA4ElEQVQ4jdWUPQuCUBSGn0LXhqDGCAeXRmktmqMpHNr6Kf6faGxVagryl4R7Yw2eCxLer3DIF+RePee8D3o9Z5AeMzy0l/XsWhD4uANTz3yGvgV/BwiANeZXP1k8UkPsGQAbi4ENsDDF1CE/gIvFSKdM83wLLPt/yCZADOyA0JATSk78C2AEJMBBAwkllkiuN6AEbkDUAlHmkeSUOhPbqMhlXX1BmuZ5S50zQEHe1A2pNHYxB/e/qACujXsnc/CbpgXwkv3dtch3XDsbK/W/k9UnmlN3ZJeaKUAFTOTqWtUHXD0eijm8FSAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search-database-icon.png
// module id = 1785
// module chunks = 0